import { useLayoutEffect, useRef, useState } from "react";

const MIN_HEIGHT_PX = 200;

export const useAvailableViewportHeight = (bottomGapPx = 64) => {
  const ref = useRef<HTMLDivElement>(null);
  const [maxHeightPx, setMaxHeightPx] = useState<number | undefined>(undefined);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    const recompute = () => {
      const { top } = element.getBoundingClientRect();
      setMaxHeightPx(
        Math.max(MIN_HEIGHT_PX, window.innerHeight - top - bottomGapPx)
      );
    };

    recompute();

    const observer = new ResizeObserver(recompute);
    for (
      let ancestor: HTMLElement | null = element.parentElement;
      ancestor != null;
      ancestor = ancestor.parentElement
    ) {
      observer.observe(ancestor);
    }

    window.addEventListener("resize", recompute);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", recompute);
    };
  }, [bottomGapPx]);

  return { ref, maxHeightPx };
};
